<template>
  <transition name="fade" mode="out-in">
    <div class="alert alert-danger alert-bottom-right" v-show="isVisible()">
      <slot><strong>Ett fel uppstod, vänligen försök igen om en stund.</strong></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'alert',
  methods: {
    isVisible () {
      return this.$store.getters.getVisibility
    }
  },
  watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Alert.vue